import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LanguagesService } from 'src/app/services/languages.service';
import { LanguagesModalComponent } from './languages-modal/languages-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-languages',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './languages.component.html',
  styleUrl: './languages.component.css'
})
export class LanguagesComponent implements OnInit {
  
  LanguagesList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  constructor(
      private dialog: MatDialog,
      private LanguagesService: LanguagesService,
      private changeDetectorRef: ChangeDetectorRef
    ) {} 

  ngOnInit(): void {
      this.getLanguages();
  }

  getLanguages(){
    this.LanguagesService.getLanguages().subscribe({
      next: (res: any) => {
        this.LanguagesList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar idiomas:', err);
        this.pagedData = [];
      } 
    });
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(LanguagesModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (!res) return
        if (res) {
          this.getLanguages();
        }
      }
    });
  }
}
